<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="[
        $t('contaCapital.numero'),
        'data da Matricula',
        $t('contaCapital.situacao'),
        'Saldo Final Integralizado Diário'
      ]"
      :showTipFooter="false"
      v-on:Load="onLoad"
    >
      <tr
        v-for="obj in this.objList"
        v-bind:key="obj.id"
      >
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.numMatricula"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.dataMatricula ? formatDate(obj.dataMatricula) : ''"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.situacaoMatricula"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.saldoFinalIntegralizadoDiario
              ? formatValue(obj.saldoFinalIntegralizadoDiario)
              : 'R$ 0,00'
          "
        />
      </tr>
    </Tables>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ContaCapitalRepository from '@/shared/http/repositories/business/capitalaccount.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'ContaCapital',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadContaCapital(this.document)
      }
    },
    onLoadContaCapital (document) {
      loading.push()
      this.document = document
      ContaCapitalRepository.Search(
        document,
        this.$refs.tableGrid.pagingLimit,
        this.$refs.tableGrid.pagingIndex
      )
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    },
    formatDate (value) {
      let result = 'Não informado'
      if (value) {
        result = this.moment(value).utcOffset(-3).format('DD/MM/YYYY')
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/capitalaccount.vue